import React from 'react'
import { Columns3 } from 'lucide-react'

export default function PanelToggleThreePanelIcon() {
    return <Columns3 width={18} height={18} />
}
